import SplitType from "split-type";
import debouncedResize from 'debounced-resize';

let splitTextInstances = [];
let animationTimeout;

const onResize = () => {
    clearTimeout(animationTimeout);

    splitTextInstances.forEach(splitTextInstance => {
        splitTextInstance.split();
    });

    animationTimeout = setTimeout(() => {
        if (!document.body.classList.contains('animations-complete')) {
            document.body.classList.add('animations-complete');
        }
    }, 1000); // Add class 1 second after resize
}

const onScroll = () => {
    clearTimeout(animationTimeout);

    animationTimeout = setTimeout(() => {
        if (!document.body.classList.contains('animations-complete')) {
            document.body.classList.add('animations-complete');
        }
    }, 1000); // Add class 1 second after scroll
}

export const splitHeroText = () => {
    document.querySelectorAll("h1").forEach(el => {
        const splitTextInstance = new SplitType(el, {
            type: 'lines',
            linesClass: 'split-lines',
            lineClass: 'split-line',
            tagName: 'span'
        });
        splitTextInstances.push(splitTextInstance);
    });

    animationTimeout = setTimeout(() => {
        document.body.classList.add('animations-complete');
    }, 2000); // Add class 2 seconds after split

    //debouncedResize(onResize);
    window.addEventListener('scroll', onScroll);
}